import React from 'react';
import Header from '../../components/Header';
import Sidebar from '../../components/Sidebar';
import TeamChatPage from './TeamChatPage';
import { useAuth } from '../../hooks/useAuth';
import { useIsMobile } from '../../hooks/useIsMobile';

function TeamChatPageWrapper() {
  const { profile } = useAuth();
  const isMobile = useIsMobile();
  const userName = profile?.name || 'Usuário';

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      height: isMobile ? '100dvh' : '100vh',
      overflow: 'hidden'
    }}>
      {!isMobile && <Header subtitle="Equipe" userName={userName} />}
      <div style={{ display: 'flex', flex: 1, overflow: 'hidden' }}>
        {!isMobile && <Sidebar activePage="equipe" />}
        <TeamChatPage />
      </div>
      {isMobile && <Sidebar activePage="equipe" />}
    </div>
  );
}

export default TeamChatPageWrapper;
